// React Imports
import type { SVGAttributes } from 'react'

const SkinDefault = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg width='104' height='66' viewBox='0 0 104 66' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect width='104' height='66' rx='4' fill='currentColor' fillOpacity='0.02' />
      <path
        d='M0 4C0 1.79086 1.79086 0 4 0H27.4717V66H4C1.79086 66 0 64.2091 0 62V4Z'
        fill='currentColor'
        fillOpacity='0.08'
      />
      <rect
        x='4.90625'
        y='23.8839'
        width='17.6604'
        height='2.78946'
        rx='1.39473'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect x='8.83008' y='5.88135' width='9.81132' height='9.70588' rx='2' fill='currentColor' fillOpacity='0.3' />
      <rect
        x='4.90625'
        y='34.4381'
        width='17.6604'
        height='2.78946'
        rx='1.39473'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect
        x='4.90625'
        y='44.9923'
        width='17.6604'
        height='2.78946'
        rx='1.39473'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect
        x='4.90625'
        y='55.5462'
        width='17.6604'
        height='2.78946'
        rx='1.39473'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect x='34.1152' y='4.67166' width='64.7547' height='8.8' rx='2' fill='currentColor' fillOpacity='0.08' />
      <rect x='37.0391' y='6.87158' width='3.92453' height='4.4' rx='1' fill='currentColor' fillOpacity='0.3' />
      <rect x='80.21' y='6.87158' width='3.92453' height='4.4' rx='1' fill='currentColor' fillOpacity='0.3' />
      <rect x='86.0957' y='6.87158' width='3.92453' height='4.4' rx='1' fill='currentColor' fillOpacity='0.3' />
      <rect x='91.9824' y='6.87158' width='3.92453' height='4.4' rx='1' fill='currentColor' fillOpacity='0.3' />
      <rect x='58.4844' y='19.6134' width='40.2264' height='17.6' rx='2' fill='currentColor' fillOpacity='0.08' />
      <rect x='34.1152' y='19.6134' width='19.0455' height='17.6' rx='2' fill='currentColor' fillOpacity='0.08' />
      <rect x='34.1152' y='42.4545' width='64.7547' height='17.6' rx='2' fill='currentColor' fillOpacity='0.08' />
    </svg>
  )
}

export default SkinDefault
